<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sln9pQ/tc-custom/9781467464161.jpg?1731796218154" alt="This image is the cover for the book The Fantastic Jungles of Henri Rousseau, Incredible Lives for Young Readers (ILYR)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Fantastic Jungles of Henri Rousseau, Incredible Lives for Young Readers (ILYR)
      </h1>
      <p class="bookDescription body article font2">
        <p>Henri Rousseau wanted to be an artist. But he had no formal training. Instead, he taught himself to paint. He painted until the jungles and animals and distant lands in his head came alive on the space of his canvases.<br/><br/> Henri Rousseau endured the harsh critics of his day and created the brilliant paintings that now hang in museums around the world. Michelle Markel's vivid text, complemented by the vibrant illustrations of Amanda Hall, artfully introduces young readers to the beloved painter and encourages all readers to persevere despite all odds.<br/><br/>Watch the trailer: <br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michelle Markel, Amanda Hall
      </h2>
      
      <p class="authorDescription body article">Michelle Markel is the author of many children's books,including Tyrannosaurus Math(Tricycle/Random House) and Dreamer from theVillage: The Story of Marc Chagall (Henry Holt).Michelle lives in California. Visit her website atwww.michellemarkel.com.,</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6d70d640